import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthState} from './store/auth.state';
import {take} from 'rxjs/operators';
import {AuthService} from './store/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authState: AuthState, private router: Router, private authService: AuthService) {
    }

    async canActivate(): Promise<boolean> {
        //return true;
        let token = (await this.authState
            .token
            .pipe(take(1))
            .toPromise()) || localStorage.getItem('token');


        if (!token) return this.nope();

        let results = await this.authState
            .check(token)
            .pipe(take(1))
            .toPromise();

        return results || this.nope();
    }

    async nope(error?){
        this.router.navigate(['login']);
        return false;
    }

}
